import {throwIfUndefined} from '@coolcolduk/util';
import {env} from '../../../config/env';

/**
 * Maps a topic string to a topic (no category)
 * @param topicString - the topic string to map to a topic (category|topic)
 * @returns the topic (topic)
 */
export default function mapTopicStringToTopic(topicString: string): string {
  const [, topic] = topicString.split(env.topic.spacer);
  return throwIfUndefined(topic, `Topic string is invalid: ${topicString}`);
}
